export default {
	MODAL_HEADER_INGREDIENT_VARIATION: 'Ingredient variation',
	TABLE_TITLE: 'Product Variant Ingredient Variations',
	POS_VARIANT_INGREDIENT_VARIATION_ADDED: 'Ingredient variation added!',
	POS_VARIANT_INGREDIENT_VARIATION_DELETED: 'Ingredient variation deleted!',
};
